// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"189":"8704b513","207":"b0a8fc99","554":"5b923bf8","911":"4bc0510c"}[chunkId] + ".css";
};